const roles = {
  rolesList: {
    rolesListTitle: "Roles List",
    roles: "Roles",
    role: "Role",
    addMoreRoles: "Add New Role",
    noRolesFound: "There is no roles yet",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by role Name",
    tableHeader: {
      roleName: "Role Name",
      employees: "Employees",
      action: "Action"
    }
  },
  roleDetails: {
    roleDetails: "Role Details",
    permissions: "Permissions",
    permission: "Permission",
    roleEmployees: "Role Employees",
    employees: "Employees",
    employee: "Employee",
    searchPlaceholder: "Search by Employee Name"
  },
  addRole: {
    addRole: "Add Role",
    editRole: "Edit Role",
    roleName: "Role Name",
    roleNamePlaceholder: "Enter the name",
    description: "Description",
    optional: "(Optional)",
    descriptionPlaceholder: "Enter the description",
    selectPermissions: "Select Permissions",
    permissions: "Permissions",
    warningModal: {
      title: "Add “Roles Management” Role !",
      content:
        "You are about to grant this employee the ability to create and assign new roles within the system. This action can affect user access and permissions across the platform. Are you sure you want to proceed?",
      proceed: "Proceed"
    }
  },
  deleteRole: {
    content: "Delete",
    confirmationContent: "Are you sure you want to delete this role?",
    subConfirmationContent: " This action cannot be undone."
  }
};

export default roles;
